import React from 'react';

export default class LadderLogoComponent extends React.PureComponent {

	render() {
		const { ladder } = this.props;
		if(!ladder) {
			console.error('Received blank ladder');
			return null;
		}
		return (
			<div className='game_logo'>
				<img
					className='game_image'
					title={ladder.name}
					src={ladder.small_image}
					alt={ladder.name}
				/>
			</div>
		);
	}
}